import {HttpParams} from '@angular/common/http';

export class RequestParameters {

  constructor(public searchString: string = '',
              public limit: number = 10,
              public offset: number = 0,
              public orderBy: OrderByRequestParameters[] = [],
              public groupBy: GroupByRequestParameters[] = [],
              public fields: FieldRequestParameters[] = [],
              public options: FieldRequestParameters[] = [],
              public pageCount = 10,
              public resultsCount: number = 0) {
    this.pageCount = this.limit;
  }

  setData(parameters: RequestParameters) {
    if (parameters.searchString !== undefined) {
      this.searchString = parameters.searchString;
    }
    this.limit = +parameters.limit;
    this.offset = +parameters.offset;
    if (parameters.groupBy !== null && parameters.groupBy !== undefined) {
      this.groupBy = parameters.groupBy;
    }
    if (parameters.fields !== null && parameters.fields !== undefined) {
      this.fields = parameters.fields;
    }
    if (parameters.orderBy !== null && parameters.orderBy !== undefined) {
      this.orderBy = parameters.orderBy;
    }
    this.resultsCount = +parameters.resultsCount;

    if ( ((this.offset + 1) * this.limit) > this.resultsCount && (this.resultsCount > this.limit) ) {
      this.pageCount = this.resultsCount - (this.offset * this.limit);
    } else {
      this.pageCount = this.limit;
    }

  }

  getHttpParams(): HttpParams  {
    let  params = new HttpParams()
      .set('limit', this.limit.toString())
      .set('offset', this.offset.toString())
      .set('searchString', this.searchString);

    // console.log(this.fields);

    for (const key in this.orderBy) {
      if (this.orderBy.hasOwnProperty(key)) {
        params = params.set('orderBy[' + key + '][field]', this.orderBy[key].field)
          .set('orderBy[' + key + '][value]', this.orderBy[key].value);
      }
    }

    for (const key in this.groupBy) {
      if (this.groupBy.hasOwnProperty(key)) {
        params = params.set('groupBy[' + key + '][field]', this.groupBy[key].field);
      }
    }

    for (const key in this.fields) {
      if (this.fields.hasOwnProperty(key)) {
        if (this.fields[key].value !== null && this.fields[key].value !== undefined) {
          params = params.set('fields[' + key + '][field]', this.fields[key].field)
            .set('fields[' + key + '][value]', this.fields[key].value);
        }

        if (this.fields[key].upperValue !== null && this.fields[key].upperValue !== undefined) {
          params = params.set('fields[' + key + '][field]', this.fields[key].field)
            .set('fields[' + key + '][upperValue]', this.fields[key].upperValue);
        }

        if (this.fields[key].lowerValue !== null && this.fields[key].lowerValue !== undefined) {
          params = params.set('fields[' + key + '][field]', this.fields[key].field)
            .set('fields[' + key + '][lowerValue]', this.fields[key].lowerValue);
        }

      }
    }
    for (const key in this.options) {
      if (this.options.hasOwnProperty(key)) {
        if (this.options[key].value !== null && this.options[key].value !== undefined) {
          params = params.set('options[' + key + '][field]', this.options[key].field)
            .set('options[' + key + '][value]', this.options[key].value);
        }

        if (this.options[key].upperValue !== null && this.options[key].upperValue !== undefined) {
          params = params.set('options[' + key + '][field]', this.options[key].field)
            .set('options[' + key + '][upperValue]', this.options[key].upperValue);
        }

        if (this.options[key].lowerValue !== null && this.options[key].lowerValue !== undefined) {
          params = params.set('options[' + key + '][field]', this.options[key].field)
            .set('options[' + key + '][lowerValue]', this.options[key].lowerValue);
        }

      }
    }

    // console.log(this.fields);

    return params;
  }

  GetHttpParams(): HttpParams  {
    let  params = new HttpParams()
      .set('limit', this.limit.toString())
      .set('offset', this.offset.toString())
      .set('searchString', this.searchString);

    // console.log(this.fields);

    for (const key in this.orderBy) {
      if (this.orderBy.hasOwnProperty(key)) {
        params = params.set('orderBy[' + key + '][field]', this.orderBy[key].field)
          .set('orderBy[' + key + '][value]', this.orderBy[key].value);
      }
    }

    for (const key in this.groupBy) {
      if (this.groupBy.hasOwnProperty(key)) {
        params = params.set('groupBy[' + key + '][field]', this.groupBy[key].field);
      }
    }

    for (const key in this.fields) {
      if (this.fields.hasOwnProperty(key)) {
        if (this.fields[key].value !== null && this.fields[key].value !== undefined) {
          params = params.set('fields[' + key + '][field]', this.fields[key].field)
            .set('fields[' + key + '][value]', this.fields[key].value);
        }

        if (this.fields[key].upperValue !== null && this.fields[key].upperValue !== undefined) {
          params = params.set('fields[' + key + '][field]', this.fields[key].field)
            .set('endDate', this.fields[key].upperValue);
        }

        if (this.fields[key].lowerValue !== null && this.fields[key].lowerValue !== undefined) {
          params = params.set('fields[' + key + '][field]', this.fields[key].field)
            .set('startDate', this.fields[key].lowerValue);
        }

      }
    }
    for (const key in this.options) {
      if (this.options.hasOwnProperty(key)) {
        if (this.options[key].value !== null && this.options[key].value !== undefined) {
          params = params.set('options[' + key + '][field]', this.options[key].field)
            .set('options[' + key + '][value]', this.options[key].value);
        }

        if (this.options[key].upperValue !== null && this.options[key].upperValue !== undefined) {
          params = params.set('options[' + key + '][field]', this.options[key].field)
            .set('options[' + key + '][upperValue]', this.options[key].upperValue);
        }

        if (this.options[key].lowerValue !== null && this.options[key].lowerValue !== undefined) {
          params = params.set('options[' + key + '][field]', this.options[key].field)
            .set('options[' + key + '][lowerValue]', this.options[key].lowerValue);
        }

      }
    }

    // console.log(this.fields);

    return params;
  }



}


export class OrderByRequestParameters {
  constructor(public field: string,
              public value: string) {

  }
}

export class GroupByRequestParameters {
  constructor(public field: string) {

  }
}

export class FieldRequestParameters {
  constructor(public field: string,
              public value: string = null,
              public lowerValue: string = null,
              public upperValue: string = null) {

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/request-parameters/parameter.model.ts